import type { SchedulerView } from "../domain/settings";
import type { DateRange } from "../domain/types";
import { addDays, isoDate, startOfWeek } from "./time";

/**
 * Inclusive date range shown for the current view.
 *
 * Week is Sunday to Saturday and Work week is that week's Monday to Friday, as classic's
 * DevExpress `WeekView` (no `firstDayOfWeek`, so Sunday; Work week excludes the weekend).
 * So a Sunday's work week is the one after it. Month's rows run Sunday to Saturday too,
 * to match (ENG-2409).
 */
export function visibleRange(view: SchedulerView, date: string): DateRange {
  if (view === "day") return { from: date, to: date };
  const sunday = startOfWeek(date);
  if (view === "workWeek")
    return { from: addDays(sunday, 1), to: addDays(sunday, 5) };
  if (view === "week") return { from: sunday, to: addDays(sunday, 6) };
  const [y, m] = date.split("-").map(Number);
  const first = isoDate(new Date(y, m - 1, 1));
  const last = isoDate(new Date(y, m, 0));
  return { from: startOfWeek(first), to: addDays(startOfWeek(last), 6) };
}

/**
 * The date ← / → moves to. Month steps to the 1st of the next or previous month: adding
 * 30 days skipped February from the 31st of January.
 */
export function stepDate(
  view: SchedulerView,
  date: string,
  direction: 1 | -1
): string {
  if (view === "day") return addDays(date, direction);
  if (view === "month") {
    const [y, m] = date.split("-").map(Number);
    return isoDate(new Date(y, m - 1 + direction, 1));
  }
  return addDays(date, 7 * direction);
}
